import React from 'react';
import { View } from '@coinscrap/webapp-core';
import InputLabel from 'components/InputLabel/InputLabel';

export const PostalCode = ({
	postalCode,
	setPostalCode,
	isPostalCorrect,
	setIsPostalCorrect,
	setMunicipality,
	postalCodeError,
}) => {
	return (
		<View inputFreeRowSt>
			<InputLabel
				value={postalCode}
				onChange={(e) => {
					setMunicipality('');
					if (isNaN(+e.target.value) || e.target.value.length > 5) return;

					if (!isPostalCorrect) {
						setIsPostalCorrect(e.target.value.length === 5);
					}
					setPostalCode(e.target.value);
				}}
				onBlur={() => {
					setIsPostalCorrect(postalCode.length === 5);
				}}
				label={'¿Cuál es tu código postal?'}
				errorMsg={
					postalCodeError
						? postalCodeError
						: !isPostalCorrect && 'Introduce un código postal válido'
				}
			/>
		</View>
	);
};
